import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { mapConfig } from '../../../../constants/component-configs';

import TerraDrawReactGoogleMapsDrawingManager from '../../../shared/drawing';

import { getDrawingMode } from '../../../../selectors/map';
import { getDrawingVisible } from '../../../../selectors/map-selection';

import {
  setDrawingMode,
  selectDrawingArea,
  selectDrawingPolygonArea,
  clearDrawingArea,
  clearAreaSelection
} from '../../../../actions/map-actions';


class MapDrawingTools extends Component {
  state = { mapsShape: null, active: false };

  componentWillReceiveProps(nextProps) {
    if (this.props.drawingMode !== nextProps.drawingMode) {
      this.props.clearDrawingArea();
      this.setState({ active: true });
    }

    if (
      this.state.mapsShape &&
      this.props.drawingVisible !== nextProps.drawingVisible &&
      !nextProps.drawingVisible
    ) {
      this.clearShape();
    }

    if (
      this.state.active === false &&
      this.props.drawingMode !== '' &&
      nextProps.drawingMode === ''
    ) {
      this.props.clearAreaSelection();
    }
  }

  clearShape = () => {
    this.state.mapsShape.setMap(null);
    this.setState({ mapsShape: null, active: false });
    this.props.setDrawingMode('');
  };

  completeCircle = (mapsShape) => {
    if (this.state.mapsShape) {
      this.state.mapsShape.setMap(null);
    }
    this.setState({ mapsShape });
    // Terra draw submits circles as polygons rather than google drawings center/radius data structure.
    // This code checks and supports either.
    if (mapsShape.center && mapsShape.radius) {
      this.props.selectDrawingArea(mapsShape.center, this.props.mapRef, mapsShape.radius, true);
    } else if (mapsShape.getPath) {
      this.props.selectDrawingPolygonArea(mapsShape.getPath().getArray());
    }
    // Clearing drawing mode causes terra draw for google maps to immediately enable double click zoom.
    // So we put a slight delay in case the user double clicks to finish drawing.
    setTimeout(() => {
      this.setState({ active: false });
    }, 500);
  };

  completePolygon = (mapsShape) => {
    if (this.state.mapsShape) {
      this.state.mapsShape.setMap(null);
    }
    this.setState({ mapsShape });
    this.props.selectDrawingPolygonArea(mapsShape.getPath().getArray());
    // Clearing drawing mode causes terra draw for google maps to immediately enable double click zoom.
    // So we put a slight delay in case the user double clicks to finish drawing.
    setTimeout(() => {
      this.setState({ active: false });
    }, 500);
  };

  
  render() {
    const { drawingMode } = this.props;
    const { active } = this.state;
    return (
      <div>
        {Boolean(drawingMode.length) &&
          <TerraDrawReactGoogleMapsDrawingManager
            drawingMode={active ? drawingMode : null}
            options={mapConfig.drawingManager}
            onPolygonComplete={this.completePolygon}
            onCircleComplete={this.completeCircle}
          />
        }
      </div>
    );
  }
}

MapDrawingTools.propTypes = {
  clearAreaSelection: PropTypes.func,
  clearDrawingArea: PropTypes.func,
  drawingMode: PropTypes.string,
  drawingVisible: PropTypes.bool,
  mapRef: PropTypes.object,
  mode: PropTypes.string,
  selectDrawingArea: PropTypes.func,
  selectDrawingPolygonArea: PropTypes.func,
  setDrawingMode: PropTypes.func
};

const mapStateToProps = state => {
  return {
    drawingMode: getDrawingMode(state),
    drawingVisible: getDrawingVisible(state)
  };
};

export default connect(mapStateToProps, {
  setDrawingMode, selectDrawingArea, selectDrawingPolygonArea, clearDrawingArea, clearAreaSelection
})(MapDrawingTools);
